import { createAction } from '@reduxjs/toolkit'
import { AppState } from '../../appState'

export const setArchiveDate = createAction<Date>('common/setArchiveDate')

export const setArchiveDateReducer = (
  state: AppState['common'],
  action: ReturnType<typeof setArchiveDate>,
): void => {
  state.archiveDate = action.payload
}
